"use client";

import { useEffect, useRef } from "react";

export default function ParallaxImageCard({
  image,
  alt,
  children,
  className = "",
  position = "center",
}) {
  const cardRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const card = cardRef.current;
    const imageEl = imageRef.current;
    if (!card || !imageEl) return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

    let frame = 0;
    const update = () => {
      frame = 0;
      const rect = card.getBoundingClientRect();
      const viewport = window.innerHeight || 1;
      const progress = (viewport - rect.top) / (viewport + rect.height) - 0.5;
      const offset = Math.max(-1, Math.min(1, progress)) * 58;
      imageEl.style.transform = `translate3d(0, ${offset}px, 0) scale(1.1)`;
    };
    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", requestUpdate);
      window.removeEventListener("resize", requestUpdate);
    };
  }, []);

  return (
    <div
      ref={cardRef}
      role="img"
      aria-label={alt}
      className={`group relative overflow-hidden rounded-2xl shadow-md ${className}`}
    >
      <div
        ref={imageRef}
        aria-hidden="true"
        className="absolute inset-[-18%] bg-cover bg-no-repeat will-change-transform"
        style={{
          backgroundImage: `url("${image}")`,
          backgroundPosition: position,
          transform: "translate3d(0, 0, 0) scale(1.1)",
        }}
      />
      {children}
    </div>
  );
}
